import React from 'react';
import { useTranslation } from 'react-i18next';
import { Text } from '@user-portal/wikr-components';

import * as S from '../styled';

const SubscriptionCardAdditionalNote = () => {
    const { t } = useTranslation();

    return (
        <S.SubscriptionCardAdditionalNote>
            <Text type="small-text" dataLocator="upsellSubscriptionNote" mb={16}>
                {t('subscriptionCard.upsellSubscription.note.text')}
            </Text>
        </S.SubscriptionCardAdditionalNote>
    );
};

export default SubscriptionCardAdditionalNote;
